import React from 'react'
import './index.scss'
import clsx from 'clsx'

interface ShareData {
    share?: number | null
    title?: string
    tooltip?: React.ReactElement
    highlight?: boolean
    overclaim?: boolean
}

const ShareDisplay = (props: ShareData) => {
    const { share, title, tooltip, highlight, overclaim } = props

    let shareColor = ''
    if (share && share >= 100 && share <= 100.06 && !overclaim) {
        shareColor = 'blue'
    } else if (overclaim && share && share > 0) {
        shareColor = 'red'
    } else if (overclaim && highlight && !share) {
        shareColor = 'green'
    }

    return (
        <div className={clsx('shares', highlight && shareColor)}>
            <span className="label-with-tooltip">
                {title}
                <span>{tooltip}</span>
            </span>
            <span className="shares-value">{share ? Math.round(share * 100) / 100 : 0}%</span>
        </div>
    )
}

export default ShareDisplay
